import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { DATA_IMAGES_TAB, DATA_SLOTS } from '~/src/features/center/constants/data';
import { COUNT_STEPS, URL_BANNER_STEPS } from '~/src/features/center/constants/ordinary';

interface ISeoPageData {
    title: string,
    description: string,
}

export interface IUrls {
    url: string,
    index: number,
}

interface ITitle {
    title: string,
}

export interface IBg {
    bgGradientPrice: string,
}

export interface IData {
    url: string,
    mUrl: string,
    text: string,
    title: string,
    bgGradient: string,
    textButton?: string,
    legal?: string,
    index: number,
}

export const getPageDataSeo = (city: ICurrentCity): ISeoPageData => {
    return {
        title: `Дом.ру сервис в ${city.cityIn}`,
        description:
            'Ваш персональный помощник поможет решить любую проблему с интернетом, телевидением или оборудованием. ' +
            `Подробности на официальном сайте Дом.ру или по телефону ${city.phone}`,
    };
};

export const getUrlsForBannerImages = (): IUrls[] => [...Array(COUNT_STEPS)].map((_, index) => {
    return { url: `${URL_BANNER_STEPS}${++index}.svg`, index };
});

export const getDataForSlots = (): IData[] => DATA_IMAGES_TAB.map((elem, index) => {
    return { url: `${URL_BANNER_STEPS}${elem.id}.png`, mUrl: `${URL_BANNER_STEPS}${elem.id}-m.png`, index, ...DATA_SLOTS[index] };
});

export const getTitleForBlocKPrice = (): ITitle[] => DATA_SLOTS.map((elem) => {
    return { title: elem.title };
});

export const getBgBlocKPrice = (): IBg[] => DATA_SLOTS.map((elem) => {
    return { bgGradientPrice: elem.bgGradientPrice };
});

export const getWithoutLineTranslation = (str?: string): string | void => {
   if (str) {
       return str.replace('\n', '');
   }
};

export const getTextLegal = (): string[] => {
    const commonText = 'Итоговая стоимость работ будет озвучена после оформления заявки оператором.';

    return [
        'Техническая помощь по услугам связи предоставляется <b>бесплатно</b>.',
        commonText,
        `Роутеры, приобретённые в Дом.ру, обслуживаются <b>бесплатно</b>. ${commonText}`,
        commonText,
        commonText,
        `${commonText} Мы подключимся к вашему устройству с помощью приложения удалённого доступа. Так мы сможем провести необходимые работы`,
        `${commonText} На ваше усмотрение услуга может быть оказана онлайн с помощью приложения удаленного доступа или через визит специалиста.`,
        `${commonText} На ваше усмотрение услуга может быть оказана онлайн или через визит специалиста.`,
    ];
};
